import GeneralTab from "./GeneralTab.vue";

import LogTab from "./LogTab.vue";

export default [GeneralTab,LogTab];
